// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Modal_wrapper__3m84f","polygon":"Modal_polygon__1f_wa","icon":"Modal_icon__30ary","button":"Modal_button__pusG1","text":"Modal_text__29yCt"};